import React, { useState } from "react";
import { useAuthContext } from "@src/context";
import { useManagerContext } from "@src/context/managerContext";
import ManagerHooks from "@src/context/hooks/managerHooks";
import DefinitionsAndFAQsSection from "../../sharedSections/DefinitionsAndFAQsSection";

export const ManagerSupportPage = () => {
  const { profile, getFirstName, getLastName } = useManagerContext();
  const auth = useAuthContext();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChanged, setIsChanged] = useState(null);

  const {
    data: { exclusions } = {},
    isPending: isPendingExclusions,
    error: errorExclusions,
  } = ManagerHooks.useGetBehaviourExclusions(auth.activeRole);
  if (errorExclusions)
    console.warn("useGetBehaviourExclusions error", errorExclusions);

  const mutationCallback = (status) => {
    setIsSubmitting(false);
    setIsChanged(status);
  };
  const mutation = ManagerHooks.useSubmitSupportRequest(mutationCallback);

  const supportObject = {
    organization: profile.customer.customerCode || "",
    fullname: `${getFirstName()} ${getLastName()}`,
    email: auth.user.username || "",
    issue: "assistance",
    message: "",
  };

  return (
    <DefinitionsAndFAQsSection
      mode="MANAGER"
      customer={profile.customer}
      bvrExclusions={exclusions}
      isLoadingBvrExclusions={isPendingExclusions}
      handleSubmitSupportForm={(message) => {
        setIsSubmitting(true);
        mutation.mutate({ ...supportObject, message });
      }}
    />
  );
};

// export const managerSupportPageControls = {};
// ManagerSupportPage.propTypes = AppUtils.getPropTypeFromControls(managerSupportPageControls);
export default ManagerSupportPage;
